/**
 * @module events/types/change
 */

/**
 * @type {string}
 */
export default 'change'
